<div id="loader" *ngIf="isLoader">
    <div id="shadow"></div>
    <div id="box"></div>
    <h4><b>Loading..</b></h4>
</div>
<div *ngIf="body">
    <mat-card style="background: transparent;">
        <mat-card class="card_style">

            <div>

                <div style="text-align: center; padding-top: 50px;">

                    <h1 style="margin-top: -18px;"><b>Nepal Wood Market Study</b></h1>

                </div>
            </div>

            <div style="text-align:left;">
                <div>
                    <div style="margin-bottom: 2%;">
                        <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                            height="35" (click)="excelExport()">
                    </div>
                     
                    <div class="table-responsive">
                        <table class="table" id="MarketStudy">
                            <thead >
                                <tr>

                                    <th scope="col" style="width: 40%;">Industry Type</th>
                                    <th scope="col" style="width: 40%;">Country</th>
                                    <th scope="col" style="width: 40%;">Latitude</th>
                                    <th scope="col" style="width: 40%;">Longitude</th>
                                    <th scope="col" style="width: 40%;">Customer</th>
                                    <th scope="col" style="width: 40%;">Whatsapp Number</th>
                                    <th scope="col" style="width: 40%;">Nationality</th>
                                    <th scope="col" style="width: 40%;">No Of Painters In Shop</th>
                                    <th scope="col" style="width: 60%;">Shop Old</th>
                                   
                                    <!--------------------------supplier-------------------------------------->
                                    <th scope="col" style="width: 60%;">Supplier 1</th>
                                    <th scope="col" style="width: 60%;">Supplier 1 Quality</th>
                                    <th scope="col" style="width: 60%;">Supplier 1 Delivery Method</th>
                                    <th scope="col" style="width: 60%;">Supplier 1 Fast_of_delivery</th>
                                    <th scope="col" style="width: 60%;">Supplier 1 Consistency in delivery</th>

                                    <th scope="col" style="width: 60%;">Supplier 2</th>
                                    <th scope="col" style="width: 60%;">Supplier 2 Quality</th>
                                    <th scope="col" style="width: 60%;">Supplier 2 Delivery Method</th>
                                    <th scope="col" style="width: 60%;">Supplier 2 Fast_of_delivery</th>
                                    <th scope="col" style="width: 60%;">Supplier 2 Consistency in delivery</th>

                                    <th scope="col" style="width: 60%;">Supplier 3</th>
                                    <th scope="col" style="width: 60%;">Supplier 3 Quality</th>
                                    <th scope="col" style="width: 60%;">Supplier 3 Delivery Method</th>
                                    <th scope="col" style="width: 60%;">Supplier 3 Fast_of_delivery</th>
                                    <th scope="col" style="width: 60%;">Supplier 3 Consistency in delivery</th>
                                    <!--------------------------------end------------------------------------->
                                    <th scope="col" style="width: 40%;">Is Painter Wear Supplier Tshirt</th>
                                    <th scope="col" style="width: 40%;">Tshirt Supplier Name</th>
                                    
                                    <th scope="col" style="width: 40%;">Paint System</th>
                                    <th scope="col" style="width: 40%;"> Sealer Consumption In Month</th>
                                    <th scope="col" style="width: 40%;">Primer Consumption In Month</th>
                                    <th scope="col" style="width: 40%;">Stain Purchase In Month</th>
                                    <th scope="col" style="width: 40%;">Thinner Consumption In Month</th> 
                                    <th scope="col" style="width: 40%;">Type Of Abrasive Using</th>
                                    <th scope="col" style="width: 40%;">Abrasive Brand</th>
                                    <th scope="col" style="width: 40%;">Wood Paints Delivery Time To Carpentry Shop</th>

                                    <th scope="col" style="width: 40%;">Technical Support From Paint Suppliers</th>
                                    <th scope="col" style="width: 40%;">Payment Term With Supplier</th>                              
                                    <th scope="col" style="width: 40%;">Credit Period</th>
                                    <th scope="col" style="width: 40%;">Mas Paints Or Other Competitors Invoice</th>
                                    <th scope="col" style="width: 40%;">Price List Of Competitors</th>
                                  
                                    <th scope="col" style="width: 40%;">Monthly Purchase Volume</th>
                                    <th scope="col" style="width: 40%;">Remarks</th>
                                    <th scope="col" style="width: 40%;">Created By</th>

                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let employee of Output">
                                    <tr>
                                        <td>{{ employee.industry_type}}</td>
                                        <td>{{ employee.country}}</td>
                                        <td>{{ employee.location.latitude}}</td>
                                        <td>{{ employee.location.longitude }}</td>
                                        <td>{{ employee.customer_name }}</td>
                                        <td>{{ employee.whatsapp_number }}</td>
                                        <td>{{ employee.owners_nationality }}</td>
                                        <td>{{ employee.no_of_painters_in_shop }}</td>
                                        <td>{{ employee.shop_old}}{{space}}{{employee.shop_old_uom}}</td>
                                       
                                        <!--------------------------supplier-------------------------------------->
                                        <td>{{ employee.current_supplier_name_1}}</td>
                                        <td>{{ employee.supplier_1_quality}}</td>
                                        <td>{{ employee.supplier_1_delivery_method}}</td>
                                        <td>{{ employee.supplier_1_fast_of_delivery}}</td>
                                        <td>{{ employee.supplier_1_consistency_in_delivery}}</td>

                                        <td>{{ employee.current_supplier_name_2}}</td>
                                        <td>{{ employee.supplier_2_quality}}</td>
                                        <td>{{ employee.supplier_2_delivery_method}}</td>
                                        <td>{{ employee.supplier_2_fast_of_delivery}}</td>
                                        <td>{{ employee.supplier_2_consistency_in_delivery}}</td>

                                        <td>{{ employee.current_supplier_name_3}}</td>
                                        <td>{{ employee.supplier_3_quality}}</td>
                                        <td>{{ employee.supplier_3_delivery_method}}</td>
                                        <td>{{ employee.supplier_3_fast_of_delivery}}</td>
                                        <td>{{ employee.supplier_3_consistency_in_delivery}}</td>


                                        <!-------------------------------end-------------------------------------->
                                        <td>{{ employee.is_painter_wear_supplier_t_shirt }}</td>
                
                                        <td>{{ employee.t_shirt_supplier_name }}</td>
                                       
                                        <td>{{ employee.paint_system }}</td>
                                        <td>{{ employee.sealer_consumption_in_month}}{{space}}{{employee.sealer_consumption_uom}}</td>
                                      
                                        <td>{{ employee.primer_consumption_in_month }}{{space}}{{ employee.primer_consumption_uom }}</td>
                                      
                                        <td>{{ employee.stain_purchase_in_month }}{{space}}{{ employee.stain_purchase_uom }}</td>

                                        <td>{{ employee.thinner_consumption_in_a_month }}{{space}}{{ employee.thinner_consumption_uom}}</td>

                                        <td>{{ employee.type_of_abrasive_using}}</td>
                                        <td>{{ employee.abrasive_brand}}</td>
                                        <td>{{ employee.wood_paints_delivery_time_to_carpentry_shop }}{{space}}Hrs</td>

                                        <td>{{ employee.is_get_technical_support_from_paint_suppliers }}</td>
                                        <td>{{ employee.payment_term_with_supplier }}</td>
                                        <td>{{ employee.credit_period}}{{space}}Days</td>
                                        <td>{{ employee.mas_paints_or_other_competitors_invoice }}</td>
                                        <td>{{ employee.price_list_of_competitors }}</td>
                                       
                                        <td>{{ employee.monthly_purchase_volume}}</td>
                                        <td>{{ employee.remarks}}</td>
                                        <td>{{ employee.created_by_name}}</td>

                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

